/**
 * 旧版 WebView Ant Design 样式兼容（如步步高学习机 Chrome 81、小度 P20 等）
 * 官方方案：StyleProvider hashPriority=high + legacyLogicalPropertiesTransformer
 *
 * 撤回方式（任选其一，改完需刷新或重启 dev）：
 * 1. 下方 CONFIG_ENABLED 改为 false
 * 2. .env 增加 VUE_APP_LEGACY_STYLE_COMPAT=false
 * 3. 删除 LegacyStyleCompatShell 组件及 App.vue 中的引用
 *
 * @see https://antdv.com/docs/vue/compatible-style-cn
 */

/** 代码开关：改为 false 即关闭兼容层 */
const CONFIG_ENABLED = true

const envDisabled = String(process.env.VUE_APP_LEGACY_STYLE_COMPAT || '').toLowerCase() === 'false'

export const ENABLE_LEGACY_STYLE_COMPAT = CONFIG_ENABLED && !envDisabled
